import * as preact from "preact";
import PropTypes from "prop-types";

import FormField from "../FormField";
import RepeatableInputFields from "../../RepeatableInputFields";

class RepeatableFormField extends preact.Component {
    handleChange = values => {
        const { name, onChange } = this.props;

        onChange(name, values);
    }

    render() {
        const {
            name,
            label,
            values,
            placeholder,
            maxInputsLength,
            validate
        } = this.props;

        return (
            <FormField label={label}>
                <RepeatableInputFields
                    name={name}
                    values={values}
                    onChange={this.handleChange}
                    maxInputsLength={maxInputsLength}
                    inputPlaceholder={placeholder}
                    inputValidate={validate}/>
            </FormField>
        );
    }
}

RepeatableFormField.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    values: PropTypes.array,
    placeholder: PropTypes.string,
    maxInputsLength: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    validate: PropTypes.func
};

export default RepeatableFormField;
